import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./CarReportSection.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
var SingleInspectionItem = function SingleInspectionItem(props) {
  var itemId = props.tabId || "item-".concat(props.index);
  return /*#__PURE__*/React.createElement("button", {
    className: stl.siiContainer,
    onClick: props.onClick && props.onClick,
    id: "inspection-".concat(itemId)
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ssi1,
    id: "inspection-".concat(itemId, "-left")
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: props.icon,
    alt: "icon",
    width: 20,
    height: 20,
    id: "inspection-".concat(itemId, "-icon")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.h3,
    id: "inspection-".concat(itemId, "-text")
  }, props.text)), /*#__PURE__*/React.createElement("div", {
    className: stl.ssi2,
    id: "inspection-".concat(itemId, "-right")
  }, props.numberOfPoints ? /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/post_exclamation.svg",
    alt: "",
    width: 22,
    height: 22,
    id: "inspection-".concat(itemId, "-warning")
  }) : /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/post_check_mark.svg",
    alt: "icon",
    width: 22,
    height: 22,
    id: "inspection-".concat(itemId, "-check")
  }), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/mobileArrL.png",
    alt: "arr",
    className: stl.arrPoint,
    width: 25,
    height: 25,
    id: "inspection-".concat(itemId, "-arrow")
  })));
};
export default SingleInspectionItem;